export default __webpack_public_path__ + "static/media/logo-politur-transfer.62c74e37.webp";